import type { FormatType, Locale, TableColumnDescriptor } from '@finance/contracts';
import { createFormatDescriptor, formatValue } from '../../../runtime/formatting';

export function inferColumnFormatType(
  column: Pick<TableColumnDescriptor, 'fieldType' | 'format'>,
): FormatType | undefined {
  if (column.format) return column.format;
  switch (column.fieldType) {
    case 'money':
      return 'currency';
    case 'number':
    case 'decimal':
      return 'decimal';
    case 'quantity':
      return 'quantity';
    case 'percentage':
      return 'percentage';
    case 'date':
      return 'date';
    case 'datetime':
      return 'datetime';
    case 'status':
      return 'status';
    default:
      return undefined;
  }
}

export function resolveRowCurrency(row?: Record<string, unknown>): string | undefined {
  const currency = row?.currency ?? row?.currencyCode ?? row?.baseCurrency;
  return typeof currency === 'string' && /^[A-Z]{3}$/.test(currency) ? currency : undefined;
}

export function formatColumnValue(
  value: unknown,
  column: Pick<TableColumnDescriptor, 'fieldType' | 'format'>,
  options: {
    locale?: Locale;
    row?: Record<string, unknown>;
  } = {},
): string {
  const formatType = inferColumnFormatType(column);
  const descriptor = formatType
    ? createFormatDescriptor(formatType, {
        currencyCode: formatType === 'currency' ? resolveRowCurrency(options.row) : undefined,
      })
    : undefined;
  return formatValue(value, descriptor, {
    locale: options.locale,
    currencyCode: resolveRowCurrency(options.row),
  });
}
